const storage = {
  setItem(key: string, value: any) {
    sessionStorage.setItem(key, JSON.stringify(value));
  },
  getItem(key: string) {
    const value = sessionStorage.getItem(key);
    if (value !== undefined && value !== null) {
      return JSON.parse(value);
    }
    return null;
  },
  removeItem(key: string) {
    sessionStorage.removeItem(key);
  },
  clearItem() {
    sessionStorage.clear();
  },
};

export default storage;
